import React, { forwardRef, useEffect, useState, useMemo } from 'react'
import DropSelect from '../../dropselect/render'

const Render = function ({
  productSlugs,
  defaultValue,
  fields = [],
  data,
  onChange,
}) {
  const [slugSelectsInfo, setSlugSelectsInfo] = useState([])
  const productFields = useMemo(() => {
    return productSlugs
      .map((v) => fields.find((f) => f.slug === v))
      .filter((v) => v && v.type === 'text')
  }, [productSlugs, fields])

  const updateSlugSelectsInfo = (info, _value, index) => {
    const arr = [...info]
    info.forEach((v, i) => {
      if (i > index) {
        arr.splice(i, 1, { ...v, value: null, title: null })
      }
      if (i === index) {
        const obj = data.find((d) => (_value || []).includes(d.objectId))
        arr.splice(i, 1, {
          ...v,
          value: _value && _value.length > 0 ? _value[0] : null,
          title: obj && obj.title,
        })
      }
    })
    onChange(
      arr.map((v) => {
        return { slug: v.slug, value: v.title, id: v.value }
      })
    )
    setSlugSelectsInfo(arr)
  }

  useEffect(() => {
    const arr = productSlugs.map((v, index) => {
      const obj = (defaultValue || []).find((d) => d && d.slug === v)
      if (obj && obj.id) {
        const _obj = data.find((d) => [obj.id].includes(d.objectId))
        return { value: obj ? obj.id : null, slug: v, index, title: _obj.title }
      }
      return { value: obj ? obj.id : null, slug: v, index }
    })
    setSlugSelectsInfo(arr)
  }, [productSlugs, defaultValue])

  return (
    <>
      {productFields.map((item, index) => {
        const currentValue =
          slugSelectsInfo[index] && slugSelectsInfo[index].value

        let selects = []
        if (index === 0) {
          selects = data
            .filter((d) => d.level === index + 1)
            .map((v) => {
              return { ...v, slug: v.objectId }
            })
        } else {
          selects = data
            .filter(
              (d) =>
                d.level === index + 1 &&
                d.parentId === slugSelectsInfo[index - 1].value
            )
            .map((v) => {
              return { ...v, slug: v.objectId }
            })
        }

        const opts = {
          ...item,
          type: 'dropSelect',
          selects,
          hint: `请选择${item.title}`,
        }

        return (
          <DropSelect
            opts={opts}
            value={[currentValue]}
            onChange={(v) => {
              updateSlugSelectsInfo(slugSelectsInfo, v, index)
            }}
          />
        )
      })}
    </>
  )
}
export default forwardRef(Render)
